import {
  Button,
  FlexBox,
  ModalBody,
  ModalFoot,
  ModalHead,
  Text,
} from '@dixa/lib-shared-habla';
import { LanguageContext } from 'lib-knowledge-management-common/contexts/language';
import { LanguageId } from 'lib-knowledge-management-common/graphql';
import { ModalWrapper, useModal } from 'lib-knowledge-modal';
import { useContext } from 'react';

type ArticlePublishErrorsModalProps = {
  articleTitle: string;
  categoryNotSet: boolean;
  titlesEmpty: LanguageId[];
  bodiesEmpty: LanguageId[];
};

export function ArticlePublishErrorsModal({
  articleTitle,
  categoryNotSet,
  bodiesEmpty,
  titlesEmpty,
}: ArticlePublishErrorsModalProps): JSX.Element {
  const { hideModal } = useModal();
  const { enabledLanguages } = useContext(LanguageContext);

  return (
    <ModalWrapper>
      <ModalHead
        title="Unable to publish article"
        onClose={hideModal}
      ></ModalHead>

      <ModalBody>
        <Text.Paragraph>
          Unable to publish <strong>“{articleTitle}”</strong>.
        </Text.Paragraph>
        <ul>
          {categoryNotSet && (
            <li>
              <Text.Paragraph>
                Category is not set for this article
              </Text.Paragraph>
            </li>
          )}

          {titlesEmpty.map((langId) => (
            <li key={langId}>
              <Text.Paragraph>
                Title is empty for language{' '}
                {
                  enabledLanguages.find((l) => l.languageId === langId)
                    ?.description
                }
              </Text.Paragraph>
            </li>
          ))}

          {bodiesEmpty.map((langId) => (
            <li key={langId}>
              <Text.Paragraph>
                Body is empty for language{' '}
                {
                  enabledLanguages.find((l) => l.languageId === langId)
                    ?.description
                }
              </Text.Paragraph>
            </li>
          ))}
        </ul>
      </ModalBody>
      <ModalFoot>
        <FlexBox justifyContent="flex-end" gap="100">
          <Button onClick={hideModal}>Ok</Button>
        </FlexBox>
      </ModalFoot>
    </ModalWrapper>
  );
}
